import { i18n } from '@/locales';
import { reportTypeList } from './baromoneyReport';
const t = i18n.t.bind(i18n);
const lc = 'views.cash_auto_deduct_group_setting.';
export const cashAutoDeductGroupSettingGroupTableHeader = [
    {
        title: t(`${lc}group_setting_table.group_name`),
        align: 'start',
        sortable: true,
        value: 'name',
        width: 226,
    },
    {
        title: t(`${lc}group_setting_table.applied_worker_in_group`),
        align: 'center',
        sortable: false,
        width: 150,
    },
    {
        title: t(`${lc}group_setting_table.group_setting`),
        align: 'center',
        sortable: false,
        width: 112,
    },
];
export const cashAutoDeductGroupSettingScheduleTableHeader = [
    // 스케쥴명
    {
        title: t(`${lc}option_setting_table.schedule_name`),
        align: 'center',
        sortable: false,
        width: 160,
    },
    // 적용 기간
    {
        title: t(`${lc}option_setting_table.period`),
        align: 'center',
        sortable: false,
        width: 225,
    },
    // 시간
    {
        title: t(`${lc}option_setting_table.schedule_type`),
        align: 'center',
        sortable: false,
        width: 108,
    },
    // 항목
    {
        title: t(`${lc}option_setting_table.account_by_worker`),
        align: 'center',
        sortable: false,
        width: 150,
    },
    // 금액
    {
        title: t(`${lc}option_setting_table.amount`),
        align: 'center',
        sortable: false,
        width: 140,
    },
    // 메모
    {
        title: t(`${lc}option_setting_table.memo`),
        align: 'center',
        sortable: false,
        width: 140,
    },
    // 수정 및 삭제
    {
        title: t(`${lc}option_setting_table.schedule_edit_or_delete`),
        align: 'center',
        sortable: false,
        width: 134,
    },
];
export const cashAutoDeductGroupWorkerListTableHeader = [
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.worker_name`),
        align: 'start',
        sortable: false,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.worker_code`),
        align: 'start',
        sortable: false,
        width: 94,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.worker_number`),
        align: 'start',
        sortable: false,
        width: 120,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.delete`),
        align: 'center',
        sortable: false,
        width: 96,
    },
];
export const availableCashAutoDeductGroupWorkerListTableHeader = [
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.worker_name`),
        align: 'start',
        sortable: false,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.worker_code`),
        align: 'start',
        sortable: false,
        width: 94,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.worker_number`),
        align: 'start',
        sortable: false,
        width: 120,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.group_name`),
        align: 'start',
        sortable: false,
        width: 180,
    },
    {
        title: t(`${lc}worker_setting_dialog.worker_list_table.add`),
        align: 'center',
        sortable: false,
        width: 96,
    },
];
const amountType = [
    '-',
    '+',
];
const accountByWorkerType = [
    'ATTEND_FEE_BY_RECURRING_PAYMENT',
    'INSURANCE_FEE_BY_RECURRING_PAYMENT',
    'PROGRAM_USE_BY_RECURRING_PAYMENT',
    'LEASE_BY_RECURRING_PAYMENT',
    'PENALTY_BY_RECURRING_PAYMENT',
    'ETC_BY_RECURRING_PAYMENT',
];
export const amountTypeList = {};
export const accountByWorkerList = {};
amountType.forEach((value, index) => {
    amountTypeList[value] = {
        text: i18n.t(`${lc}option_setting_table.amount_type_code_text[${index}]`),
        value,
    };
});
accountByWorkerType.forEach((value) => {
    const accountByWorker = reportTypeList[value];
    accountByWorkerList[value] = {
        text: i18n.t(`views.baromoney_report.table_item.${accountByWorker}`),
        value,
    };
});
